import { SessionMessage } from '../../session-message/session-message';

export function evaluateObjectionHandlingPrompt(sessionMessageList: SessionMessage[], methodology: string) {
  let chatHistory = '';

  sessionMessageList.forEach((message) => {
    chatHistory += `Sales: ${message.subData.salesMessage} \n Customer: ${message.subData.customerMessage} \n`;
  });

  return `
Analyze the methodology and chat history to evaluate objection handling effectiveness. Create a comprehensive table with the following columns:
- Objections
- Good Response Example
- Sales Response
- Scores (1-5)

Sort the table by Score in descending order. Provide only the table without additional explanations.

Chat History:
<CHAT_HISTORY>
${chatHistory}
</CHAT_HISTORY>

Methodology:
<METHODLOGY>
${methodology}
</METHODLOGY>

`;
}
